import type { TypeTextDetailed } from 'types/autogen/contentful';
import RichText from './shared/RichText';
import { useContentfulInspectorMode } from '@contentful/live-preview/react';

export default function Text(props: TypeTextDetailed) {
    const {
        fields: { richText },
        sys: { id }
    } = props;
    if (!richText) return;

    const inspectorProps = useContentfulInspectorMode({ entryId: id });

    return (
        <div {...inspectorProps({ fieldId: 'richText' })}>
            <RichText {...richText} />
        </div>
    );
}
